import React from 'react';
import { Flex } from 'rebass';
import useJobPost from 'modules/JobPosts/hooks/useJobPost';
import JobPostDetailsNavigation from 'modules/JobPosts/components/JobPostDetailsNavigation';
import JobPostDetails from 'modules/JobPosts/components/JobPostDetails';
import Frame from 'components/Frame';

const JobPostDetailsPage: React.FC<any> = ({ userRole, match }): JSX.Element => {
  const { jobPost, userInfo } = useJobPost(+match.params.id);
  return (
    <Flex>
      <Frame>
        <Flex width="100%" flexDirection="column" pt={7}>
          <JobPostDetailsNavigation userRole={userRole} userJobPost={jobPost} userInfo={userInfo} />
          <JobPostDetails jobPost={jobPost} companyName={jobPost.companyName} />
        </Flex>
      </Frame>
    </Flex>
  );
};

export default JobPostDetailsPage;
